import { BikeListItem, IBikeSearchResponseBike, IBikeSearchResponseProduct } from 'PyzShopUi/scripts/product-detail-page/interfaces';

export const mapBikeSearchResponseProductsToBikes = (products: IBikeSearchResponseProduct[]): BikeListItem[] => {
    const bikeMap: Map<String, BikeListItem> = products.reduce(
        (resultBikeMap: Map<string, BikeListItem>, product: IBikeSearchResponseProduct) => {
            if ("length" in product.bikes) {
                product.bikes.forEach((bike: IBikeSearchResponseBike) => {
                    addBikeToBikeMap(resultBikeMap, bike, product);
                });
            } else {
                const bike: IBikeSearchResponseBike = product.bikes;
                addBikeToBikeMap(resultBikeMap, bike, product);
            }
            return resultBikeMap;
        },
        new Map<string, any>()
    );

    return Array.from(bikeMap.values());
};

const addBikeToBikeMap = (bikeMap: Map<string, BikeListItem>, bike: IBikeSearchResponseBike, product: IBikeSearchResponseProduct) => {
    if (!bikeMap.has(bike.bike_code)) {
        bikeMap.set(bike.bike_code, {
            bike_code: bike.bike_code,
            name: bike.name,
            manufacture_year_start: bike.manufacture_year_start,
            manufacture_year_end: bike.manufacture_year_end,
            model: bike.model,
            products: [
                {
                    concrete_id: product.concrete_id,
                    bike_association: bike.bike_association,
                }
            ],
        });
    } else {
        const bikeEntry: BikeListItem = bikeMap.get(bike.bike_code);
        bikeEntry.products.push({
            concrete_id: product.concrete_id,
            bike_association: bike.bike_association,
        });
    }
}
